import React from 'react';
import LabelInput, { SelectData } from './LabelImput';

interface AdressComponnentState {
  country_ISO2: string;
  hasGender: boolean;
  isGenderMissing: boolean;
  hasFirma: boolean;
  hasVorname: boolean;
  hasNachname: boolean;
  hasStrasse: boolean;
  hasHausnummer: boolean;
  hasZip: boolean;
  hasOrt: boolean;
  isValid: boolean;
}

export interface AdressComponnentProp {
  adress_id?: number;
  gender?: 'C' | 'H' | 'F' | 'd';
  firma: string;
  vorname: string;
  nachname: string;
  strasse: string;
  hausnummer: string;
  abteilung: string;
  zusatz1: string;
  zusatz2: string;
  zip: string;
  ort: string;
  country_id: number;
  country_ISO2: string;
  countrys: SelectData[];
  idPostfix?: string;
  readonly?: boolean;
  isCompanyNotRequired?: boolean;
  isValidNotify?: (valid: boolean) => void;
}

export default class AdressComponnent extends React.Component<
  AdressComponnentProp,
  AdressComponnentState
> {
  constructor(prop: AdressComponnentProp) {
    super(prop);

    let stateTemp = {
      hasGender: prop.gender != undefined,
      hasFirma: prop.firma != undefined && prop.firma != '',
      hasVorname: prop.vorname != undefined && prop.vorname != '',
      hasNachname: prop.nachname != undefined && prop.nachname != '',
      hasStrasse: prop.strasse != undefined && prop.strasse != '',
      hasHausnummer: prop.hausnummer != undefined && prop.hausnummer != '',
      hasZip: prop.zip != undefined && prop.zip != '',
      hasOrt: prop.ort != undefined && prop.ort != '',
    };

    let isValid = this.isValid(stateTemp);

    this.state = {
      country_ISO2: this.props.country_ISO2,
      hasGender: stateTemp.hasGender,
      isGenderMissing: false,
      hasFirma: stateTemp.hasFirma,
      hasVorname: stateTemp.hasVorname,
      hasNachname: stateTemp.hasNachname,
      hasStrasse: stateTemp.hasStrasse,
      hasHausnummer: stateTemp.hasHausnummer,
      hasZip: stateTemp.hasZip,
      hasOrt: stateTemp.hasOrt,
      isValid: isValid,
    };
  }

  isValid(stateTemp: {
    hasGender: boolean;
    hasFirma: boolean;
    hasVorname: boolean;
    hasNachname: boolean;
    hasStrasse: boolean;
    hasHausnummer: boolean;
    hasZip: boolean;
    hasOrt: boolean;
  }): boolean {
    let result =
      stateTemp.hasGender &&
      (stateTemp.hasFirma || this.props.isCompanyNotRequired == true) &&
      stateTemp.hasVorname &&
      stateTemp.hasNachname &&
      stateTemp.hasStrasse &&
      stateTemp.hasHausnummer &&
      stateTemp.hasZip &&
      stateTemp.hasOrt;

    return result;
  }

  componentDidMount(): void {
    let isValid = this.isValid({
      hasGender: this.state.hasGender,
      hasFirma: this.state.hasFirma,
      hasVorname: this.state.hasVorname,
      hasNachname: this.state.hasNachname,
      hasStrasse: this.state.hasStrasse,
      hasHausnummer: this.state.hasHausnummer,
      hasZip: this.state.hasZip,
      hasOrt: this.state.hasOrt,
    });

    if (this.props.isValidNotify != undefined)
      this.props.isValidNotify(isValid);
  }

  componentDidUpdate(prevProp: any, prevState: any) {
    let isValid = this.isValid({
      hasGender: this.state.hasGender,
      hasFirma: this.state.hasFirma,
      hasVorname: this.state.hasVorname,
      hasNachname: this.state.hasNachname,
      hasStrasse: this.state.hasStrasse,
      hasHausnummer: this.state.hasHausnummer,
      hasZip: this.state.hasZip,
      hasOrt: this.state.hasOrt,
    });

    if (this.state.isValid != isValid) {
      this.setState({ isValid: isValid });
      if (this.props.isValidNotify != undefined)
        this.props.isValidNotify(isValid);
    }
  }

  render(): React.ReactNode {
    let idPostFix = '';
    if (this.props.idPostfix != undefined) idPostFix = this.props.idPostfix;
    let onLandChange = (ev) => {
      let newId = ev.currentTarget.value;
      let newItem: any = this.props.countrys.find((f) => f.id == newId);
      let newCode = newItem.iso_code_2;
      this.setState({ country_ISO2: newCode });
    };
    let genderDivStyle: React.CSSProperties = {};
    if (this.state.isGenderMissing) {
      genderDivStyle.border = '1px solid red';
      genderDivStyle.padding = '0.5em';
    }

    return (
      <div
        onBlur={() => {
          if (!this.state.hasGender) {
            this.setState({ isGenderMissing: true });
          }
        }}
      >
        <div style={genderDivStyle}>
          <input
            type="radio"
            name={'anrede' + idPostFix}
            tabIndex={1}
            id={'anrede_Firma' + idPostFix}
            value="C"
            defaultChecked={this.props.gender == 'C'}
            readOnly={this.props.readonly}
            onChange={(ev) => {
              if (!this.state.hasGender)
                this.setState({ hasGender: true, isGenderMissing: false });
            }}
          />

          <label htmlFor={'anrede_Firma' + idPostFix}>Firma</label>
          <input
            type="radio"
            name={'anrede' + idPostFix}
            id={'anrede_Herr' + idPostFix}
            value="H"
            defaultChecked={this.props.gender == 'H'}
            readOnly={this.props.readonly}
            onChange={(ev) => {
              if (!this.state.hasGender)
                this.setState({ hasGender: true, isGenderMissing: false });
            }}
          />
          <label htmlFor={'anrede_Herr' + idPostFix}>Herr</label>
          <input
            type="radio"
            name={'anrede' + idPostFix}
            id={'anrede_Frau' + idPostFix}
            value="F"
            defaultChecked={this.props.gender == 'F'}
            readOnly={this.props.readonly}
            onChange={(ev) => {
              if (!this.state.hasGender)
                this.setState({ hasGender: true, isGenderMissing: false });
            }}
          />
          <label htmlFor={'anrede_Frau' + idPostFix}>Frau</label>
          <input
            type="radio"
            name={'anrede' + idPostFix}
            id={'anrede_divers' + idPostFix}
            value="d"
            defaultChecked={this.props.gender == 'd'}
            readOnly={this.props.readonly}
            onChange={(ev) => {
              if (!this.state.hasGender)
                this.setState({ hasGender: true, isGenderMissing: false });
            }}
          />
          <label htmlFor="anrede_divers">Divers</label>
        </div>
        <br className="clearBoth" />
        <LabelInput
          id={'firma' + idPostFix}
          labelText="Firma"
          type="text"
          name={'firma' + idPostFix}
          requied={this.props.isCompanyNotRequired != true}
          inputDynparam={{
            defaultValue: this.props.firma,
            readOnly: this.props.readonly,
          }}
          onChange={(ev) => {
            let newState = ev.target.value != '';
            if (this.state.hasFirma != newState)
              this.setState({ hasFirma: newState });
          }}
        />
        <LabelInput
          id={'vorname' + idPostFix}
          labelText="Vorname"
          type="text"
          name={'vorname' + idPostFix}
          requied={true}
          inputDynparam={{
            defaultValue: this.props.vorname,
            readOnly: this.props.readonly,
          }}
          onChange={(ev) => {
            let newState = ev.target.value != '';
            if (this.state.hasVorname != newState)
              this.setState({ hasVorname: newState });
          }}
        />

        <LabelInput
          id={'nachname' + idPostFix}
          labelText="Nachname"
          type="text"
          name={'nachname' + idPostFix}
          requied={true}
          inputDynparam={{
            defaultValue: this.props.nachname,
            readOnly: this.props.readonly,
          }}
          onChange={(ev) => {
            let newState = ev.target.value != '';
            if (this.state.hasNachname != newState)
              this.setState({ hasNachname: newState });
          }}
        />
        <LabelInput
          id={'strasse' + idPostFix}
          labelText="Straße"
          type="text"
          name={'strasse' + idPostFix}
          requied={true}
          inputDynparam={{
            defaultValue: this.props.strasse,
            readOnly: this.props.readonly,
          }}
          onChange={(ev) => {
            let newState = ev.target.value != '';
            if (this.state.hasStrasse != newState)
              this.setState({ hasStrasse: newState });
          }}
        />
        <LabelInput
          id={'hausnummer' + idPostFix}
          labelText="Hausnummer"
          type="text"
          name={'hausnummer' + idPostFix}
          requied={true}
          inputDynparam={{
            defaultValue: this.props.hausnummer,
            readOnly: this.props.readonly,
          }}
          onChange={(ev) => {
            let newState = ev.target.value != '';
            if (this.state.hasHausnummer != newState)
              this.setState({ hasHausnummer: newState });
          }}
        />
        <LabelInput
          id={'abteilung' + idPostFix}
          labelText="Abteilung"
          type="text"
          name={'abteilung' + idPostFix}
          inputDynparam={{
            defaultValue: this.props.abteilung,
            readOnly: this.props.readonly,
          }}
        />
        <LabelInput
          id={'zusatz1' + idPostFix}
          labelText="Zusatz 1"
          type="text"
          name={'zusatz1' + idPostFix}
          inputDynparam={{
            defaultValue: this.props.zusatz1,
            readOnly: this.props.readonly,
          }}
        />
        <LabelInput
          id={'zusatz2' + idPostFix}
          labelText="Zusatz 2"
          type="text"
          name={'zusatz2' + idPostFix}
          inputDynparam={{
            defaultValue: this.props.zusatz2,
            readOnly: this.props.readonly,
          }}
        />
        <LabelInput
          id={'zip' + idPostFix}
          labelText="PLZ"
          type="text"
          name={'zip' + idPostFix}
          requied={true}
          inputDynparam={{
            defaultValue: this.props.zip,
            readOnly: this.props.readonly,
          }}
          onChange={(ev) => {
            let newState = ev.target.value != '';
            if (this.state.hasZip != newState)
              this.setState({ hasZip: newState });
          }}
        />
        <LabelInput
          id={'ort' + idPostFix}
          labelText="Ort"
          type="text"
          name={'ort' + idPostFix}
          requied={true}
          inputDynparam={{
            defaultValue: this.props.ort,
            readOnly: this.props.readonly,
          }}
          onChange={(ev) => {
            let newState = ev.target.value != '';
            if (this.state.hasOrt != newState)
              this.setState({ hasOrt: newState });
          }}
        />
        <LabelInput
          id={'land' + idPostFix}
          labelText="Land"
          type="select"
          name={'land' + idPostFix}
          requied={true}
          selectData={{
            data: this.props.countrys,
            selected: this.props.country_id,
          }}
          inputDynparam={{
            readOnly: this.props.readonly,
            onChange: onLandChange,
          }}
        />
        <LabelInput
          id={'adress_id' + idPostFix}
          labelText=""
          type="hidden"
          name={'adress_id' + idPostFix}
          inputDynparam={{ defaultValue: this.props.adress_id }}
        />
        <input type={'hidden'} name={'edit' + idPostFix} defaultValue="" />
        <input
          type={'hidden'}
          name={'readonly' + idPostFix}
          defaultValue={this.props.readonly == true ? 'true' : 'false'}
        />
        <input
          type={'hidden'}
          name={'land_code' + idPostFix}
          defaultValue={this.state.country_ISO2}
        />
      </div>
    );
  }
}

export function getEmptyAddressProp(
  contrys: SelectData[],
): AdressComponnentProp {
  return {
    firma: '',
    vorname: '',
    nachname: '',
    strasse: '',
    hausnummer: '',
    abteilung: '',
    zusatz1: '',
    zusatz2: '',
    zip: '',
    ort: '',
    country_id: 81,
    countrys: contrys,
    country_ISO2: 'DE',
    readonly: false,
  };
}
